import React, { useState } from 'react';
import { formatUSDT } from '../../utils/format';
import {
  useMachineDisplay,
  formatXtRange,
  formatUsdtRangeFromXt,
} from '../../hooks/useMachineDisplay';
import { useXtPrice } from '../../hooks/useXtPrice';
import {
  TIER_LABELS,
  MACHINE_IMAGES,
  TIER_TIER_LEVEL,
} from '../../utils/constants';

export default function MachineCard({ tier, index, selected, onOpen }) {
  const [imgError, setImgError] = useState(false);
  const { config } = useMachineDisplay();
  const { xtPrice } = useXtPrice();
  if (!tier || !tier.active) return null;

  const name = TIER_LABELS[index] || `Tier ${index + 1}`;
  const image = MACHINE_IMAGES[index];
  const rank = TIER_TIER_LEVEL[index] || 'NORMAL';
  const xtRange = formatXtRange(index, config);
  const usdtRange = formatUsdtRangeFromXt(index, config, xtPrice);
  const totalDays = Number(tier.miningDays);

  return (
    <div
      className={`machine-card ${selected ? 'selected' : ''}`}
      onClick={() => onOpen(index)}
    >
      <div className={`machine-tier-badge tier-${rank}`}>{rank}</div>
      {selected && <div className="machine-selected-badge">SELECTED</div>}

      <div className="machine-image-wrap">
        {imgError || !image ? (
          <div className="machine-fallback">
            <div className="machine-fallback-hex" />
            <div className="machine-fallback-icon">⛏</div>
          </div>
        ) : (
          <img
            className="machine-image"
            src={image}
            alt={name}
            onError={() => setImgError(true)}
          />
        )}
      </div>

      <div className="machine-body">
        <div className="machine-name">{name}</div>
        <div className="machine-price">
          {formatUSDT(tier.priceUSDT, 0)}<span className="cur">USDT</span>
        </div>
        <div className="machine-daily">
          Earns <strong>{xtRange} XT</strong> tokens per day
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2, fontFamily: 'var(--font-mono)' }}>
            ≈ {usdtRange} USDT / day
          </div>
        </div>
        <div className="machine-specs">
          <div className="spec">
            Runtime<strong>{totalDays}d</strong>
          </div>
          <div className="spec" style={{ textAlign: 'right' }}>
            Total Yield<strong>{Number(tier.miningDays) * Number(tier.miningDays > 0 ? 1 : 0) || totalDays} mining cycles</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
